import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataHh from './phonics/phonics_data_hh';

/**
 * Phonics Letter Hh 页面
 */
function PhonicsHh() {
  return <PhonicsAtoZ letterData={letterDataHh} />;
}

export default PhonicsHh;
